import React from "react"
import type { CartelasFornecedorState, FiltroCartelas } from "../models/cartelasFornecedorModel"
import { CartelasFornecedorInicial } from "../models/cartelasFornecedorModel"
import type { CartelasFornecedorAction } from "./cartelasFornecedorActions"

interface CartelasFornecedorContextType {
    dados: CartelasFornecedorState
    dispatch: React.Dispatch<CartelasFornecedorAction>
    erroCarregamento: string | null
    buscar: (filtro: FiltroCartelas, pagina: number) => void
}

export const CartelasFornecedorContext = React.createContext<CartelasFornecedorContextType>({
    dados: CartelasFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    buscar: () => undefined,
})
